import Alpine from 'alpinejs';
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse';
import persist from '@alpinejs/persist';

import { beforeAfter } from './beforeAfter.js';
import { landingPageChip } from './landingPageChip.js';
import embedAssetResizer from './embedAssetResizer';
import { swiper, lightboxSlideshow, showcaseSlideshow } from './swiper';

Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(persist);

Alpine.data('beforeAfter', beforeAfter);
Alpine.data('landingPageChip', landingPageChip);
Alpine.data('embedAssetResizer', embedAssetResizer);
Alpine.data('swiper', swiper);
Alpine.data('lightboxSlideshow', lightboxSlideshow);
Alpine.data('showcaseSlideshow', showcaseSlideshow);

window.Alpine = Alpine;
Alpine.start();
